import { Component } from '@angular/core';

import { environment } from '../../environments/environment';

@Component({
  selector: 'app-logged-out',
  template: `
    <div class="logged-out-container">
      <img src="https://moveright.app/brand/logos/color-horizontal.svg"
           alt="Move Right"
           class="logo" />
      <h1>Thank you for using Move Right</h1>
      <p>You've been logged out. Your data is safe and ready when you are.</p>
      <div class="resources">
        <a href="https://moveright.app/training" target="_blank" class="resource-link">
          <span class="icon">📚</span> Training
        </a>
        <a href="https://moveright.app/resources" target="_blank" class="resource-link">
          <span class="icon">💡</span> Resources
        </a>
        <a href="https://moveright.app/how-it-works" target="_blank" class="resource-link">
          <span class="icon">⚡</span> How It Works
        </a>
        <a href="https://moveright.app/releases" target="_blank" class="resource-link">
          <span class="icon">🚀</span> Product Updates
        </a>
      </div>
      <a [href]="loginUrl" class="sign-in-btn">Sign Back In</a>
      <p class="support">
        Need help? <a href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;support&#64;moveright.app">support&#64;moveright.app</a>
      </p>
    </div>
  `,
  styles: [`
    .logged-out-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      text-align: center;
      font-family: 'Plus Jakarta Sans', sans-serif;
      background: #f8fafc;
      padding: 2rem;
    }
    .logo {
      max-width: 240px;
      margin-bottom: 2rem;
    }
    h1 {
      font-size: 1.75rem;
      color: #0f172a;
      margin-bottom: 0.5rem;
      font-weight: 800;
    }
    p {
      color: #64748b;
      margin-bottom: 2rem;
    }
    .resources {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      justify-content: center;
      margin-bottom: 2rem;
    }
    .resource-link {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.5rem 1rem;
      background: white;
      border: 1px solid #e2e8f0;
      border-radius: 0.5rem;
      color: #334155;
      text-decoration: none;
      font-weight: 500;
      transition: border-color 0.2s;
    }
    .resource-link:hover {
      border-color: #6ab33d;
    }
    .sign-in-btn {
      display: inline-block;
      padding: 0.75rem 2rem;
      background: #6ab33d;
      color: white;
      text-decoration: none;
      border-radius: 0.5rem;
      font-weight: 600;
      transition: background 0.2s;
      box-shadow: 0 5px 0 0 #508a2e;
      margin-bottom: 2rem;
    }
    .sign-in-btn:hover {
      background: #508a2e;
      transform: translateY(2px);
      box-shadow: 0 3px 0 0 #508a2e;
    }
    .support {
      font-size: 0.875rem;
    }
    .support a {
      color: #6ab33d;
      text-decoration: none;
    }
  `],
})
export class AppLoggedOutComponent {
  loginUrl: string;

  constructor() {
    this.loginUrl = `${environment.authUrl}/oauth2/authorize`
      + `?client_id=${environment.authClientId}`
      + `&redirect_uri=${encodeURIComponent(environment.authCallbackUrl)}`
      + `&response_type=code`
      + `&scope=openid offline_access email`
      + `&state=/dashboard`;
  }
}